import Stats from "../../mycomp/Dashboard/Sales/Stats";
import SalesReport from "../../mycomp/Dashboard/CRM/SalesReport";
import { Row, Col } from "react-bootstrap";


const MemberAnalytics = () =>{
  return(
    <>
      <Row>
        <Stats />
      </Row>
      <Row>
        <Col sm={12} md={12} lg={12}><SalesReport /></Col>
      </Row>
    </>
  );
};

export default MemberAnalytics;